import Wrapper from "../../layout/wrapper/Wrapper";

interface IProps {
    children?: React.ReactNode;
    containsImage?: boolean;
}

export default function CardBody(props: IProps) {
    return (
        <Wrapper className={`userful-card-body ${props.containsImage ? "userful-card-contains-image" : ""}`}>
            {props.children}
        </Wrapper>
    );
}
